import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { environment } from 'src/environments/environment';
@Injectable({ providedIn: 'root' })
export class WhatsappService extends BaseService {
  GetMessages() {
    const url = `${environment.portalApi}/Whatsapp/GetMessages`;
    return this.http.get(url, { headers: this.createHeader() });
  }
  PostDeclaracaoMatricula(request: any) {
    let data = {
      files: request
    }
    const url = `${environment.portalApi}/Whatsapp/PostDeclaracaoMatricula`;
    return this.http.post(url, JSON.stringify(data), { headers: this.createHeader(), responseType: 'blob', observe: 'response' });
  }
}
